import { useQuery } from "@apollo/client";
import { Combobox } from "@/components/Combobox";
import { graphql, type ResultOf } from "@/graphql";
import { useActiveBusinessUnit } from "@/hooks/use-active-business-unit";
import { removeNothings } from "@/lib/utils/arrays";
import { type StateCode, isValidStateCode, STATE_DATA } from "@/lib/utils/states";

type Props = {
  id?: string;
  selected: Array<StateCode>;
  onSelect: (values: Array<StateCode>) => void;
  className?: string;
};

export type SourceStateData = ResultOf<typeof sourceStateCodesQuery>;

export function SourceStatePicker({ id, selected, onSelect, className }: Props) {
  const { activeBusinessUnitId } = useActiveBusinessUnit();
  const { data, loading } = useQuery(sourceStateCodesQuery, {
    variables: { businessUnit: activeBusinessUnitId },
  });

  const options = getStateOptions(removeNothings(data?.supplyChainLotSourceStateCodes || []));

  return (
    <Combobox<StateCode>
      id={id}
      name="source-states"
      options={options}
      selected={selected}
      onChange={onSelect}
      loading={loading}
      type="multi"
      className={className}
    />
  );
}

export const sourceStateCodesQuery = graphql(`
  query SupplyChainLotSourceStateCodes($businessUnit: ID) {
    supplyChainLotSourceStateCodes(businessUnit: $businessUnit)
  }
`);

export const getStateOptions = (stateCodes: string[]) => {
  const options = stateCodes.filter(isValidStateCode).map((stateCode) => {
    return {
      label: STATE_DATA[stateCode],
      value: stateCode,
    };
  });

  return options;
};
